export default ({
  RELOAD_REMINDERS: 'RELOAD_REMINDERS',
  USER_LOGOUT: 'USER_LOGOUT',
});
